import Event from './SystemEvents';
import dotenv from 'dotenv';

module.exports = () => {
    Event.emit('loadCli', process.cwd());
}